import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Since from "./../../assets/360_F_467403170_ga6cRos4Q0lfBsU67XsMd0mx9zC0wFCM.webp";
import Img1 from "./../../assets/Comercial/Yercaudhotel/01.webp";
import Img2 from "./../../assets/residential/Priya vinoth/priya vinoth 3d.jpg";

const VisionaryTeam = () => {
  // Separate refs for different sections
  const headingRef = useRef(null);
  const featuresRef = useRef(null);
  const descriptionRef = useRef(null);

  // Ensure each section has its own observer
  const headingInView = useInView(headingRef, { threshold: 0.3, once: true });
  const featuresInView = useInView(featuresRef, { threshold: 0.3, once: true });
  const descriptionInView = useInView(descriptionRef, { threshold: 0.3, once: true });

  const features = [
    { text: "Legacy of Excellence Since 1972", img: Since },
    { text: "Innovative & Sustainable Architecture", img: "https://img.freepik.com/free-photo/digital-screen-with-environment-day_23-2148884835.jpg?t=st=1742472220~exp=1742475820~hmac=894be0b9d2699620270078e3e78821138a732b3552d220d714c0a8d7ceeae19b&w=826" },
    { text: " End-to-End Architectural & Engineering Solutions", img: Img1 },
    { text: " Cutting-Edge 3D Visualization & Smart Design Techniques", img: Img2 },
  ];

  return (
    <div style={styles.container}>
      {/* Heading */}
      <motion.h2
        ref={headingRef} // Ensure ref is assigned properly
        style={styles.heading}
        initial={{ opacity: 0, x: -50 }}
        animate={headingInView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Why <span style={{ color: "#5c0e14", fontSize: "50px" }}>Choose</span> Us
      </motion.h2>

      <motion.p
        style={styles.subText}
        initial={{ opacity: 0, y: 30 }}
        animate={headingInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
      >
       Our legacy is built on <span style={{ fontWeight: "bold" }}> innovation, sustainability, and functionality,</span> delivering <span style={{ fontWeight: "bold" }}>exceptional spaces</span> that enhance both <span style={{ fontWeight: "bold" }}>urban and industrial landscapes.</span> We specialize in <span style={{ fontWeight: "bold" }}>residential, commercial, industrial, and institutional architecture,</span> ensuring <span style={{ fontWeight: "bold" }}></span>future-ready, eco-friendly, and structurally sound designs. Our commitment to <span style={{ fontWeight: "bold" }}></span>quality and precision is backed by advanced <span style={{ fontWeight: "bold" }}>3D visualization, BIM modelling, and cutting-edge engineering solutions,</span> helping clients bring their visions to life seamlessly.
      </motion.p>

      {/* Features Grid */}
      <div ref={featuresRef} style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            style={styles.featureCard}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={featuresInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.3 }}
          >
            <img src={feature.img} alt={feature.text} style={styles.image} />
            <p style={styles.featureText}>{feature.text}</p>
          </motion.div>
        ))}
      </div>

      {/* Final Description */}
      <motion.p
        ref={descriptionRef} // Ensure description has its own observer
        style={styles.description}
        initial={{ opacity: 0, y: 30 }}
        animate={descriptionInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
      >
        Samson and Associates is redefining the way spaces are designed, seamlessly blending innovation, functionality, and sustainability. We envision environments that not only shape skylines but also enhance the way people live, work, and connect. Our designs go beyond structures—they inspire lifestyles, influence daily experiences, and create a lasting impact on communities.
      </motion.p>
    </div>
  );
};

// Styles
const styles = {
  container: {
    backgroundColor: "#f5f5f5",
    //minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "5vw",
    textAlign: "center",
  },
  heading: {
    fontSize: "clamp(2rem, 5vw, 3rem)",
    fontWeight: "bold",
    color: "#111",
    marginBottom: "10px",
  },
  subText: {
    fontSize: "clamp(1rem, 2vw, 1rem)",
    color: "grey",
    marginBottom: "40px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
    gap: "40px",
    width: "100%",
    maxWidth: "1500px",
  },
  featureCard: {
    backgroundColor: "#5c0e14",
    borderRadius: "12px",
    overflow: "hidden",
    textAlign: "center",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
  },
  image: {
    width: "100%",
    height: "300px",
    objectFit: "cover",
  },
  featureText: {
    fontSize: "18px",
    fontWeight: "200",
    color: "#f0e193",
    padding: "16px",
  },
  description: {
    marginTop: "40px",
    maxWidth: "700px",
    fontSize: "16px",
    color: "#666",
  },
};

export default VisionaryTeam;
